import axios from "../../lib/axiosInstance";

/**
 * Inbox API — the conversation view of messaging.
 *
 * Unlike `notifications/messages`, which returns notification events that the
 * client then has to group by conversationId, these endpoints return one row per
 * conversation already carrying its latest message, sender and unread count.
 * The server exposes them at both `inbox` (web) and `mobile/inbox` (app).
 */

export function fetchInbox({ cursor = null, limit = 20 } = {}) {
  return axios.get(`inbox`, { params: { cursor, limit } }).then((res) => res.data);
}

export function fetchConversation(
  conversationId,
  { limit = null, before = null, markAsRead = true } = {},
) {
  return axios
    .get(`inbox/${conversationId}`, { params: { limit, before, markAsRead } })
    .then((res) => res.data);
}

export function sendInboxMessage({
  conversationId,
  message,
  digitalAssetIds = [],
  messageType = null,
  replyToId = null,
}) {
  return axios
    .post(`inbox/${conversationId}/message`, {
      message,
      digitalAssetIds,
      messageType,
      ...(replyToId ? { replyToId } : {}),
    })
    .then((res) => res.data);
}

export function markInboxConversationAsRead(conversationId) {
  return axios.patch(`inbox/${conversationId}/read`).then((res) => res.data);
}

export function markAllInboxConversationsAsRead() {
  return axios.patch(`inbox/readAll`).then((res) => res.data);
}
